export function buildMtrSnMappingsPayload(rows, updatedAt) {
  const seen = new Set();
  const snMappingIds = [];

  (rows ?? []).forEach((row) => {
    const id = String(row?.id ?? '').trim();
    if (!id || seen.has(id)) {
      return;
    }
    seen.add(id);
    snMappingIds.push(id);
  });

  return {
    snMappingIds,
    updatedAt: updatedAt ?? null,
  };
}

export function sortMtrSnMappings(rows) {
  return [...(rows ?? [])].sort((left, right) => {
    const leftCode = String(left?.productCode ?? '');
    const rightCode = String(right?.productCode ?? '');
    const byCode = leftCode.localeCompare(rightCode);
    if (byCode !== 0) {
      return byCode;
    }
    return String(left?.id ?? '').localeCompare(String(right?.id ?? ''));
  });
}

export function mapMtrSnMappingRow(row) {
  return {
    id: row?.id ?? '',
    productCode: row?.productCode ?? '',
    productName: row?.productName ?? '',
    status: row?.status ?? '',
  };
}
